import { render, staticRenderFns } from "./speed-dial.vue?vue&type=template&id=3bc7839e&scoped=true"
import script from "./speed-dial.vue?vue&type=script&lang=js"
export * from "./speed-dial.vue?vue&type=script&lang=js"
import style0 from "./speed-dial.vue?vue&type=style&index=0&id=3bc7839e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc7839e",
  null
  
)

export default component.exports